import { brandedString } from 'src/helpers/brandedString';

// @todo: Ideally schema would expose them
export const ApplicationListActions = brandedString({
  CREATE_TENANT: 'tenant-management:tenant.create',
  DELETE: 'tenant-management:application-list.delete',
  READ: 'tenant-management:application-list.read',
  UPDATE_APPLICATIONS: 'tenant-management:application-list.update-applications',
  UPDATE_MANAGERS: 'tenant-management:application-list.update-managers',
  UPDATE_MANAGING_APPLICATIONS:
    'tenant-management:application-list.update-managing-applications',
  UPDATE_NAME: 'tenant-management:application-list.update-name',
  UPDATE_OWNERS: 'tenant-management:application-list.update-owners',
});
